// extracted by mini-css-extract-plugin
module.exports = {"container":"NewCalendar_container__30L3r"};